import jQuery from 'jquery';
import jQueryForm from 'jquery-form';
import epFormWidget from './ep-form-widget';

export default function(){
	jQuery(function(){
		jQuery('.in-layer-form').on('click', function(evt){
			evt.preventDefault();
			
			const link = jQuery(this);
			const url = link.data('href');
			const title = link.data('title');
			const overlayWidth = link.data('overlay-width');

			
			jQuery.ajax({
				url: url,
				cache: false
			}).then(function(data){
				const showAjaxForm = function(content){
					const initAjaxForm = function(formElm){
						formElm.epform({
							selectors: {
								form: ''
							},
							onSubmitListener: function(event){
								const formElm = jQuery(this);
								formElm.ajaxSubmit({ 
									error: function(){
										$.ep.overlayWidget.close();
									},
									success: function(responseText){
										showAjaxForm(jQuery(responseText));
									}
								});
								
								event.preventDefault();
							}
						});
					}

					const options = {
						title: title,
						content: content,
						width: overlayWidth ?? "350px",
						maxWidth: '95%',
						maxHeight: '95%',
					};
					$.ep.overlayWidget.mount(options, link);
					const form = content.is('form') ? content : content.find('form');
					initAjaxForm(form);
				}
				
				showAjaxForm(jQuery(data));
			});
		});
	});
}
